import DeveloperError from './DeveloperError';
class DeveloperNotFound extends DeveloperError {
    developerId;
    constructor(developerId, options) {
        super('DEVELOPER_NOT_FOUND', options);
        this.developerId = developerId;
    }
}
export default DeveloperNotFound;
